import styled from 'styled-components';

const Header = () => {
    return (
        <Wrap>
            <div className="con wh100per flex aic jcsb">
                <span className="logo-box img-box">
                    <img src="./img/logo.svg" alt="" />
                </span>
                <a href="#contact" className='shortcut-btn flex aic jcc'>
                    <span className="img-box">
                        <img src="./img/ico_chalkboard_fff.svg" alt="" />
                    </span>
                    <span className="text">도입 문의</span>
                </a>
            </div>
        </Wrap>
    );
}

export default Header;

const Wrap = styled.header`
    width: 100%;
    height: 88px;
    background: #fff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    position: fixed;
    z-index: 3;
    top: 0;
    left: 0;
    @media (max-width: 1400px) {
        height: 6.2857vw;
    }
    @media (max-width: 767px) {
        height: 72px;
    }

    .logo-box {
        width: 257px;
        @media (max-width: 1400px) {
        width: 18.3571vw;
        }
        @media (max-width: 767px) {
            width: 180px;
        }
    }

    .shortcut-btn {
        width: 147px;
        height: 48px;
        gap: 8px;
        border-radius: 8px;
        background-color: ${props => props.theme.mainColor1};
        @media (max-width: 1400px) {
            width: 10.5vw;
            height: 3.4285vw;
            gap: 0.5714vw;
            border-radius: 0.5714vw;
        }
        @media (max-width: 767px) {
            width: 91px;
            height: 32px;
            gap: 4px;
            border-radius: 8px;
        }

        > .img-box {
            width: 24px;
            @media (max-width: 1400px) {
                width: 1.7142vw;
            }
            @media (max-width: 767px) {
                width: 18px;
            }
        }

        > .text {
            font-size: 18px;
            color: #fff;
            @media (max-width: 1400px) {
                font-size: 1.2857vw;
            }
            @media (max-width: 767px) {
                font-size: 12px;
            }
        }
    }
`